import { forwardRef } from 'react';
import CheckboxInternal from './checkbox-internal';
var Checkbox = forwardRef(CheckboxInternal);
export default Checkbox;
